<template>
    <div class="users">
        <el-row class="user-title" :gutter="4">
            <el-col :span="18">
                <span class="h3">{{$t('cheng_yuan_lie_biao')}}</span>
            </el-col>
            <el-col :span="6" class="user-list-filter">
                <el-form label-width="auto">
                    <el-form-item :label="$t('tiao_jian_sou_suo')">
                        <el-input :placeholder="$t('qing_shu_ru_yuan_gong_ming_cheng')" class="user-input-filter"
                                  prefix-icon="el-icon-search" v-model="pagination.info"
                                  @change="loadDeviceSearch"
                                  clearable></el-input>
                    </el-form-item>
                </el-form>
            </el-col>
        </el-row>
        <div class="user-data-list">
            <el-table :data="users">
                <el-table-column :label="$t('cheng_yuan_xin_xi')" align="center">
                    <template slot-scope="scope">
                        <div class="user-info">
                            <div class="user-info-img"><img :src="scope.row.avatar"/></div>
                            <div class="user-info-detail">
                                <p>{{scope.row.name}}</p>
                            </div>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column :label="$t('shou_ji')" align="center" prop="phone"></el-table-column>
                <el-table-column :label="$t('bang_ding_shi_jian')" align="center">
                    <template slot-scope="scope">
                        <span>{{new Date(scope.row.createdAt * 1000).Format('yyyy-MM-dd hh:mm:ss')}}</span>
                    </template>
                </el-table-column>
                <el-table-column :label="$t('cao_zuo')" align="center" prop="name">
                    <template slot-scope="scope">
                        <p v-show="scope.row.uuid != employee.enterpriseUuid">
                            <span @click="handleEdit(scope.row)" class="user-edit">{{$t('bian_ji')}}</span>
                            <span @click="handleGroup(scope.row)" class="user-edit">{{$t('cheng_yuan_fen_zu')}}</span>
                            <span @click="handleDelete(scope.row, scope.$index)" class="user-delete">{{$t('shan_chu')}}</span>
                        </p>
                        <p v-show="scope.row.uuid == employee.enterpriseUuid">
                          <span @click="handleEdit(scope.row)" class="user-edit">{{$t('bian_ji')}}</span>
                        </p>

                    </template>
                </el-table-column>
            </el-table>
        </div>
        <el-pagination
                @current-change="handleCurrentChange"
                class="pagination"
                :current-page="pagination.curPage"
                :page-size="pagination.limit"
                layout="total, prev, pager, next, jumper"
                :total="pagination.total">
        </el-pagination>

        <c-dialog :visible.sync="editUserVisible" :title="$t('bian_ji_cheng_yuan')" :width="'30rem'" :height="'28rem'">
          <el-form label-width="80px" class="add-user-form">
            <el-form-item :label="$t('cheng_yuan_ming_cheng')">
              <el-input :placeholder="$t('qing_shu_ru_cheng_yuan_ming_cheng')" v-model="user.name"/>
            </el-form-item>
            <el-form-item :label="$t('tou_xiang')">
              <img class="department-user-img" :src="user.avatar" alt="">
            </el-form-item>
            <el-form-item :label="$t('shou_ji')">
              <el-input :placeholder="$t('qing_shu_ru_cheng_yuan_shou_ji')" v-model="user.phone"/>
            </el-form-item>
            <el-form-item :label="$t('deng_lu_mi_ma')">
              <el-input :placeholder="$t('qing_shu_ru_cheng_yuan_deng_lu_mi_ma')" v-model="user.password"/>
            </el-form-item>
            <el-form-item>
                    <el-button type="primary" @click="handleEditUser">{{$t('que_ding')}}</el-button>
                </el-form-item>
            </el-form>
        </c-dialog>

        <c-dialog :visible.sync="groupUserVisible" :title="$t('cheng_yuan_fen_zu')" :width="'30rem'" :height="'24rem'">
            <div class="check">
                <el-checkbox-group v-model="userGroup.groupUuid">
                    <el-checkbox v-for="tag in canAllocateGroups"
                                 :key="tag.name" :label="tag.uuid">{{tag.name}}
                    </el-checkbox>
                </el-checkbox-group>
            </div>
            <div class="save">
                <el-button @click="saveUserDepartment">{{$t('bao_cun')}}</el-button>
            </div>

        </c-dialog>
    </div>

</template>

<script>
    import {departmentEmployeeUnion, departmentEmployeeList} from '@/api/account/department'
    import {
        employeeEdit,
        employeeDelete,
        employeeDepartmentIn,
        employeeCanAllocateDepartment,
        employeeAllocateDepartment
    } from '@/api/account/employee'
    import CDialog from '@/components/Dialog'
    import {checkPhone} from '@/util/checkLogin'
    import {mapGetters} from 'vuex'
    import {hex_md5} from '@/util/md5'
    export default {
        name: '',
        components: {
            CDialog
        },
        mounted: function () {
            this.initDevice()
            employeeCanAllocateDepartment().then(res => {
                this.canAllocateGroups = res.data || []
            })
        },
        computed: {
            ...mapGetters(['employee'])
        },
        data: function () {
            return {
                users: [],
                editUserVisible: false,
                groupUserVisible: false,
                user: {},
                userGroup: {
                    employeeUuid: '',
                    groupUuid: []
                },
                canAllocateGroups: [],
                pagination: {
                    info: '',
                    start: 0,
                    curPage: 1,
                    limit: 10,
                    total: 0,
                },
            }
        },
        methods: {
            initDevice() {
                this.pagination.start = 0
                departmentEmployeeUnion(this.pagination).then(res => {
                    this.users = res.data.list || []
                    this.pagination.total = parseInt(res.data.total)
                })
            },
            handleCurrentChange(value){
                this.pagination.curPage = value
                this.pagination.start = (value - 1) * this.pagination.limit
                departmentEmployeeList(this.pagination).then(res => {
                    this.users = res.data
                })
            },
            loadDeviceSearch(){
                let vue = this
                this.pagination.curPage = 1
                this.pagination.start = 0
                departmentEmployeeUnion(this.pagination).then(res => {
                    vue.users = res.data.list || []
                    vue.pagination.total = parseInt(res.data.total)
                })
            },

            handleEdit(row) {
                this.user = row
                this.editUserVisible = true
            },
            handleGroup(row) {
                this.userGroup.employeeUuid = row.uuid
                employeeDepartmentIn({uuid: row.uuid}).then(res => {
                    this.userGroup.groupUuid = (res.data || []).map(val => {
                        return val.uuid
                    })
                    this.groupUserVisible = true
                })

            },
            saveUserDepartment() {
                employeeAllocateDepartment(this.userGroup).then(() => {
                    this.$message.success(this.$t('fen_pei_cheng_gong'))
                    this.groupUserVisible = false
                })
            },
            handleDelete(row) {
                this.$confirm(this.$t('ci_cao_zuo_jiang_yi_chu_cheng_yuan'), this.$t('ti_shi'), {
                    confirmButtonText: this.$t('que_ding'),
                    cancelButtonText: this.$t('qu_xiao'),
                    type: 'warning'
                }).then(() => {
                    employeeDelete({uuid: row.uuid}).then(() => {
                        this.initDevice(this.pagination.departmentUuid)
                    })
                }).catch(() => {

                })
            },


            handleEditUser(){
                let vue = this
                let res = checkPhone(vue.user.phone)
                if (!res.status) {
                    vue.$message.error(res.msg)
                    return
                }

                if (!vue.user.name.length) {
                    vue.$message.error(this.$t('qing_shu_ru_yuan_gong_ming_cheng'))
                    return
                }

                if (!vue.user.password.length) {
                    vue.$message.error(this.$t('qing_shu_ru_yuan_gong_deng_lu_mi_ma'))
                    return
                }

                employeeEdit({name: vue.user.name,
                  avatar: vue.user.avatar || 'https://sass-img.iyyclub.com/avatar.jpg',
                  uuid:vue.user.uuid,
                  phone:vue.user.phone,
                  password: hex_md5(vue.user.password)
                }).then(() => {
                    vue.editUserVisible = false
                    vue.$message.success(this.$t('xiu_gai_cheng_gong'))
                })
            }
        },
    }
</script>

<style lang="scss">
    .users {
        padding: $padding $t-padding;
        display: flex;
        flex-direction: column;
        .user-title {
            .user-input-filter {
                input {
                    border: none;
                    border-bottom: 1px solid $f_fiv_color;
                    font-size: $filter-font-size;
                    border-radius: 0;
                }
            }
        }
        .user-data-list {
            flex: 1;

            .user-info {
                display: flex;
                align-items: center;
                text-align: left;
                .user-info-img {
                    img {
                        max-width: 2rem;
                    }
                }
                .user-info-detail {
                    margin-left: $padding;
                    p {
                        margin-bottom: $padding-5;
                    }
                    p:first-child {
                        font-size: .8rem;
                    }
                }
            }

            .el-table {
                thead {
                    tr {
                        th {
                            border-bottom: 1px solid $border_sec_color;
                        }
                    }
                }

            }
            .el-table--group::after, .el-table--border::after, .el-table::before {
                background-color: transparent;
            }
            .el-table__row:hover {
                background-color: $bg_sec_color;
            }

            .user-edit, .user-delete {
                cursor: pointer;
                display: inline-block;
                margin-right: $padding;
            }
            .user-edit {
                color: $btn_color;
            }
            .user-delete {
                color: $btn_sec_color;
            }

        }

        .pagination {
            margin: $padding;
            text-align: right;
        }

        .department-user-img {
            width: 3rem;
            height: 3rem;
            line-height: 3rem;
            background-color: $bg_sec_color;
        }
        .content-wrapper {
            height: 90%;
        }

        .check {
            height: 90%;
            overflow-y: scroll;
            margin-bottom: $padding;
            .el-checkbox {
                width: 18%;
                margin-bottom: $padding-5;
            }
        }
        .save {
            text-align: center;
        }

    }

</style>
